<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p style="text-indent:0em">I AM ONLY HUMAN</p>
<p style="text-indent:0em">I laugh and I cry</p>
<p style="text-indent:0em">I slip and I slide</p>
<p style="text-indent:0em">But I still continue to try.</p>
<p style="text-indent:0em">I am only human.</p>
<p style="text-indent:0em">I fall, I bleed,</p>
<p style="text-indent:0em">I bruise, I heal.</p>
<p style="text-indent:0em">I hate, I love.</p>
<p style="text-indent:0em">Invariably, I am only human.</p>
<p style="text-indent:0em">I have strong emotions and opinions.</p>
<p style="text-indent:0em">Some I feel inherently connected to, others fade with the setting sun.</p>
<p style="text-indent:0em">Time after time, I am hated, I am loved!</p>
<p style="text-indent:0em">Can you tell that I am only human?</p>
<p style="text-indent:0em">I often chide to hide the pain.</p>
<p style="text-indent:0em">When I feel like I’ll never breathe again,</p>
<p style="text-indent:0em">I lash out and speak aloud,</p>
<p style="text-indent:0em">Don’t judge me! Don’t you see that I am only human?</p>
<p style="text-indent:0em">Like a tiger caught in a trap,</p>
<p style="text-indent:0em">I won’t be held back.</p>
<p style="text-indent:0em">At those times, my actions are racialised so they can be politicised</p>
<p style="text-indent:0em">I’ll never know why because I am only human.</p>
<p style="text-indent:0em">If I am only human, why does my skin tone inspire hate?</p>
<p style="text-indent:0em">Why does the width of my nose and the volume of my thighs get some people high?</p>
<p style="text-indent:0em">You know why?</p>
<p style="text-indent:0em">It serves their purpose: to divide, to ostracise, to further minimise.</p>
<p style="text-indent:0em">Look again because it is not always about race and engendering strife.</p>
<p style="text-indent:0em">It is more so about taking up space.</p>
<p style="text-indent:0em">But we’ve been hardwired to see faces, in places where a soul should dwell.</p>
<p style="text-indent:0em">Therefore, we must unlearn to relearn how to tap into souls.</p>
<p style="text-indent:0em">Ultimately and irrevocably, I am only human.</p>
<p style="text-indent:0em">So, pick a side, choose humanity</p>
<p style="text-indent:0em">Just try because you know why?</p>
<p style="text-indent:0em">You and I are only human.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2b7a7840